/**
 * @ngdoc directive
 * @name customheader
 *
 * @description
 * Page footer (for event page)
 */
module.directive('customfooter', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
            // get copyright enhancement
            var $watcherGlobal = $rootScope.$watchCollection('config.global', function (config) {
                if (config && config.start_copyright) {
                    $scope.content.field_copyright = config.start_copyright;
                }
            });

            // remove $watchers
            $scope.$on('$destroy', function () {
                $watcherGlobal();
            });
        }],
        template:
                '<div class="aqua-customfooter" ng-style="{\'color\': content.field_theme_footer.color_text, \'background-color\': content.field_theme_footer.color_background}">' +
                '  <div class="grid-main">' +
                '    <div class="grid grid-between grid-middle">' +
                '      <p class="aqua-customfooter--copyright">{{content.field_copyright}} {{content.field_teaser}}</p>' +
                '      <ul class="aqua-customfooter--links grid grid-right" ng-style="{\'color\': content.field_theme_footer.color_link}">' +
                '        <li class="aqua-customfooter--links--item" ng-repeat="link in content.field_links">' +
                '          <a class="aqua-customfooter--links--item-text" ng-href="{{link.uri}}">{{link.title}}</a>' +
                '        </li>' +
                '      </ul>' +
                '    </div>' +
                '  </div>' +
                '</div>'
    };
});